export class ScreenChangeNotice {
    constructor(screenName, senderId, data) {
        this.senderId = "unknown";
        this.type = "screenChange";
        this.screenName = screenName;
        if (senderId) {
            this.senderId = senderId;
        }
        this.data = data;
    }
    static getType() {
        return "screenChange";
    }
}
